/**
 * CF7 Popups: open popup on link click (#formularz, #kalendarz), close on backdrop/Escape
 */
(function () {
    var popupIdByHash = {
        '#formularz': 'ws-cf7-popup-formularz',
        '#kalendarz': 'ws-cf7-popup-kalendarz',
    };

    function openPopup(id) {
        var popup = document.getElementById(id);
        if (!popup) return;
        popup.removeAttribute('hidden');
        popup.setAttribute('aria-hidden', 'false');
        void popup.offsetWidth;
        popup.classList.add('is-open');
        document.body.classList.add('ws-cf7-popup-open');
        document.addEventListener('keydown', onKeydown);
    }

    function closePopup(id) {
        var popup = id ? document.getElementById(id) : null;
        if (popup) {
            popup.classList.remove('is-open');
            popup.setAttribute('aria-hidden', 'true');
            var handler = function () {
                popup.setAttribute('hidden', '');
                popup.removeEventListener('transitionend', handler);
            };
            popup.addEventListener('transitionend', handler);
        }
        document.body.classList.remove('ws-cf7-popup-open');
        document.removeEventListener('keydown', onKeydown);
    }

    function onKeydown(e) {
        if (e.key === 'Escape') {
            var openPopups = document.querySelectorAll('.ws-cf7-popup.is-open');
            if (openPopups.length) {
                closePopup(openPopups[openPopups.length - 1].id);
            }
        }
    }

    function init() {
        document.addEventListener('click', function (e) {
            var target = e.target && e.target.closest ? e.target : null;
            if (!target) return;

            // 1. Close: backdrop or X button (check first so X/backdrop always work)
            var closeEl = target.closest ? target.closest('[data-cf7-popup-close]') : null;
            if (closeEl) {
                e.preventDefault();
                e.stopPropagation();
                var popup = closeEl.closest('.ws-cf7-popup');
                if (popup && popup.id) closePopup(popup.id);
                return;
            }

            // 2. Open: link with href="#formularz" or href="#kalendarz"
            var link = target.closest ? target.closest('a[href^="#"]') : null;
            if (!link) return;
            var href = (link.getAttribute('href') || '').trim();
            var id = popupIdByHash[href];
            if (id) {
                e.preventDefault();
                openPopup(id);
            }
        });
    }

    document.addEventListener('DOMContentLoaded', init);
})();
